import { useState } from 'react'
import Swal from 'sweetalert2';
import { useAdminInfo } from '../../../../../hooks/useAdminInfo';
import { addCoins } from '../../../Api/LoadPanel/LoadPanel';
import { Request } from '../../../Api/Requests/models';
import { approveRequest } from '../../../Api/Requests/Requests';

interface Props {
    request: Request
    onHide: () => void
    form: {
        recipient: string
        sender: string
    }
}

export const useAutoLoad = ({ request, onHide, form }: Props) => {
    // const { getTime } = useGetTimeForHistory()
    const { adminInfo } = useAdminInfo()
    const [loading, setLoading] = useState(false)

    const handleSuccess = async () => {
        await approveRequest({ id: request.id })
        onHide()
    }

    // CONFIRM ADD COINS
    const confirmAddCoins = async ({ isBonus }: { isBonus: boolean }) => {
        if (loading) { return }

        const formattedQuantity = Number(request.amount).toLocaleString("es-ES", {
            maximumFractionDigits: 2,
        });

        if (adminInfo?.useMaxLoadValue && adminInfo?.maxLoadValue && (Number(request.amount) >= adminInfo?.maxLoadValue)) {
            Swal.fire({
                html: `¿Estás por cargar <span style="color:var(--primary-color)">${formattedQuantity}</span> fichas ${isBonus ? 'bonificadas al 100%' : ''} al usuario <span style="color:var(--primary-color)">${request.Player?.platformUser}</span>, deseas continuar?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'var(--main-color)',
                confirmButtonText: 'Si, Cargar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    setLoading(true)
                    handleCoins({ isBonus });
                } else {
                    setLoading(false);
                    return;
                }

            });
        } else {
            handleCoins({ isBonus });
        }
    }



    // MAIN FUNCTION
    const handleCoins = async ({ isBonus }: { isBonus: boolean }) => {
        setLoading(true)
        try {
            const result = await addCoins({
                name: request.Player?.platformUser,
                quantity: request.amount.toString(),
                isBonus: isBonus ? true : false,
                destinationAccountName: form.recipient ?? '',
                senderName: form.sender
            })

            if (result?.data?.success) {
                Swal.fire({ icon: 'success', text: `${request.amount} fichas cargadas a ${request.Player?.platformUser}` })
                handleSuccess()
            } else {
                const errorMessage = result?.response?.data?.message ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({
                    icon: 'error',
                    text: errorMessage,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
            }

        } catch (error: any) {
            let errorMessage = error?.response?.data?.message ?? 'ERROR: No se ha podido cargar, verifica tu conexión y que tengas fichas disponibles.'
            console.log(error)
            Swal.fire({ icon: 'error', text: errorMessage, allowOutsideClick: false, allowEscapeKey: false });
        } finally {
            setLoading(false)
        }
    }


    return { confirmAddCoins, loadingLoad: loading }
}
